// i18n
import { translate } from 'infras/i18n';

import { RestClientResponse } from 'infras/rest_client';
import { ErrorList } from 'domains/models';

export function getErrorMessage(
  result: RestClientResponse,
  defaultErrorMessage?: string,
) {
  let errorMessage = defaultErrorMessage || translate('errors.General error');
  if (typeof result.errors === 'object') {
    const firstError = Object.keys(result.errors)[0];
    if (
      Array.isArray(result.errors[firstError]) &&
      result.errors[firstError].length > 0
    ) {
      errorMessage = result.errors[firstError][0];
    }
  }
  return errorMessage;
}

export function checkCalendarIntegrationError(errors: ErrorList) {
  return (
    typeof errors === 'object' &&
    Object.keys(errors).length > 0 &&
    Object.values(errors)
      .flatMap((e) => e)
      .some(
        (e: any) =>
          typeof e === 'object' &&
          (e.code === 'WARN-204002' || e.code === 'WARN-204003'),
      )
  );
}
